var table_viewer_default = {
  "viewMode": "e9-n9",
  "editMode": "_2Nipu",
  "container": "ezNr3",
  "cell": "fkdH-"
};
export {
  table_viewer_default as default
};
//# sourceMappingURL=table-viewer-scss.js.map
